import { Col, Container, Row, FormGroup, Label } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { WithdrawTitle, WithdrawHistory } from "../../../utils/Constant";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import HistoryTable from "../../../CommonElements/SearchTable/SearchTable";
import { WithDrawReport } from "../../../Data/TableData/TableData";
import { Formik, Field, Form, FieldProps, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import { useEffect, useState } from "react";
import { decryptData } from "../../../utils/helper/Crypto";
import { format } from "date-fns";

interface FormValues {
  FromDate: Date | null;
  ToDate: Date | null;
  Status: string;
}

const DepositHistoryPageContainer = () => {
  const [memberID] = useState(
    decryptData(localStorage.getItem("clientId") as string)
  );

  const [API_Payload, setAPIPayload] = useState<any>({});
  const [SeaarchData_date, setSeaarchData_date] = useState<any>(null);

  const twoDaysAgo = new Date();
  twoDaysAgo.setDate(twoDaysAgo.getDate() - 30);

  const initialValues: FormValues = {
    FromDate: twoDaysAgo, // default 30 days ago
    ToDate: new Date(),
    Status: "All",
  };

  // 🔹 Default Load Effect
  useEffect(() => {
    if (memberID) {
      const formattedFromDate = format(initialValues.FromDate!, "dd-MMMM-yyyy");
      const formattedToDate = format(initialValues.ToDate!, "dd-MMMM-yyyy");

      setSeaarchData_date({
        FormDate: formattedFromDate,
        ToDate: formattedToDate,
      });

      setAPIPayload({
        procName: "USP_WithdrawFund", // ✅ fixed procName
        Para: JSON.stringify({
          ClientId: memberID,
          FromDate: formattedFromDate,
          ToDate: formattedToDate,
          Status: "All",
          ActionMode: "Search",
          page: 1, // ✅ added pagination defaults
          size: 10,
          search: "",
        }),
      });
    }
  }, [memberID]);

  // 🔹 On Submit
  const handleSubmit = (values: FormValues) => {
    const { Status } = values;
    const formattedFromDate = format(values.FromDate!, "dd-MMMM-yyyy");
    const formattedToDate = format(values.ToDate!, "dd-MMMM-yyyy");

    setSeaarchData_date({
      FormDate: formattedFromDate,
      ToDate: formattedToDate,
    });

    setAPIPayload({
      procName: "USP_WithdrawFund", // ✅ fixed procName
      Para: JSON.stringify({
        ClientId: memberID,
        FromDate: formattedFromDate,
        ToDate: formattedToDate,
        Status,
        ActionMode: "Search",
        page: 1, // reset to first page when searching
        size: 10,
        search: "",
      }),
    });
  };

  return (
    <>
      <Breadcrumbs
        mainTitle={WithdrawHistory}
        parent={WithdrawTitle}
        ChildName={WithdrawHistory}
      />

      <Container fluid>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({ setFieldValue, values }) => (
            <Form>
              <Row>
                <Col xl="12">
                  <Row>
                    <Col md="3">
                      <FormGroup>
                        <Label>From Date:</Label>
                        <Field name="FromDate">
                          {({ field }: FieldProps) => (
                            <DatePicker
                              className="form-control"
                              selected={values.FromDate}
                              onChange={(date) =>
                                setFieldValue("FromDate", date)
                              }
                              dateFormat="dd-MMMM-yyyy"
                              placeholderText="dd-MMMM-yyyy"
                            />
                          )}
                        </Field>
                        <ErrorMessage name="FromDate" component="div" />
                      </FormGroup>
                    </Col>

                    <Col md="3">
                      <FormGroup>
                        <Label>To Date:</Label>
                        <Field name="ToDate">
                          {({ field }: FieldProps) => (
                            <DatePicker
                              className="form-control"
                              selected={values.ToDate}
                              onChange={(date) => setFieldValue("ToDate", date)}
                              dateFormat="dd-MMMM-yyyy"
                              placeholderText="dd-MMMM-yyyy"
                            />
                          )}
                        </Field>
                        <ErrorMessage name="ToDate" component="div" />
                      </FormGroup>
                    </Col>

                    <Col md="3">
                      <FormGroup>
                        <Label>Status</Label>
                        <Field
                          name="Status"
                          as="select"
                          className="form-control btn-square form-select"
                        >
                          <option value="All">All</option>
                          <option value="Pending">Pending</option>
                          <option value="Paid">Paid</option>
                          <option value="Cancelled">Cancelled</option>
                          <option value="Rejected">Rejected</option>
                        </Field>
                        <ErrorMessage name="Status" component="div" />
                      </FormGroup>
                    </Col>

                    <Col
                      md="3"
                      className="d-flex align-items-center justify-content-start pb-2 pb-md-0"
                    >
                      <Btn color="primary mt-0 mt-md-3" type="submit">
                        Search
                      </Btn>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>

        {/* 🔹 Table */}
        <HistoryTable
          ColumnData={WithDrawReport}
          SeaarchData_date={SeaarchData_date}
          PageCate="Payout"
          apiPayload={API_Payload}
        />
      </Container>
    </>
  );
};

export default DepositHistoryPageContainer;
